module.exports = __webpack_public_path__ + "img/hislogo.e94390dc.png";